export default "__VITE_ASSET__DfFZ2nBi__"